/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Answer
 */
export interface Answer {
    /**
     * 
     * @type {number}
     * @memberof Answer
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof Answer
     */
    text: string;
    /**
     * 
     * @type {boolean}
     * @memberof Answer
     */
    correct: boolean;
    /**
     * 
     * @type {number}
     * @memberof Answer
     */
    attempt: number;
    /**
     * 
     * @type {number}
     * @memberof Answer
     */
    question: number;
    /**
     * 
     * @type {number}
     * @memberof Answer
     */
    mcAnswer?: number | null;
}

/**
 * Check if a given object implements the Answer interface.
 */
export function instanceOfAnswer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "correct" in value;
    isInstance = isInstance && "attempt" in value;
    isInstance = isInstance && "question" in value;

    return isInstance;
}

export function AnswerFromJSON(json: any): Answer {
    return AnswerFromJSONTyped(json, false);
}

export function AnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Answer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'text': json['text'],
        'correct': json['correct'],
        'attempt': json['attempt'],
        'question': json['question'],
        'mcAnswer': !exists(json, 'mc_answer') ? undefined : json['mc_answer'],
    };
}

export function AnswerToJSON(value?: Answer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'correct': value.correct,
        'attempt': value.attempt,
        'question': value.question,
        'mc_answer': value.mcAnswer,
    };
}

